/* Article navigation. Source headings remain readable without JavaScript. */
(() => {
  if (window.neobayArticleNavigation) return;
  window.neobayArticleNavigation = true;

  function initialize(scope = document) {
    scope.querySelectorAll('.blog-article-main').forEach((main) => {
      const content = main.querySelector('.blog-post-content');
      const nav = main.querySelector('[data-toc-nav]');
      const card = main.querySelector('[data-toc-card]');
      if (!content || !nav || !card || nav.dataset.ready) return;
      nav.dataset.ready = 'true';
      const headings = [...content.querySelectorAll('h2, h3')].filter(
        (heading) => heading.textContent.trim() && !heading.closest('.blog-product-card')
      );
      headings.forEach((heading, index) => {
        if (!heading.id) {
          const base = `article-section-${index + 1}`;
          let id = base;
          let suffix = 1;
          while (document.getElementById(id)) id = `${base}-${suffix++}`;
          heading.id = id;
        }
        heading.style.scrollMarginTop = '112px';
        const link = document.createElement('a');
        link.className = 'blog-toc-card__link';
        link.href = `#${encodeURIComponent(heading.id)}`;
        link.textContent = heading.textContent.trim();
        nav.append(link);
      });
      card.hidden = headings.length === 0;
      card.style.display = headings.length ? '' : 'none';
    });
  }

  let scheduled = false;
  function progress() {
    scheduled = false;
    const content = document.querySelector('.blog-post-content');
    const bar = document.querySelector('.blog-article-progress');
    if (!content || !bar) return;
    const bounds = content.getBoundingClientRect();
    const distance = Math.max(1, bounds.height - window.innerHeight);
    const percent = Math.max(0, Math.min(100, (-bounds.top / distance) * 100));
    bar.style.width = `${percent}%`;
  }
  function scheduleProgress() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(progress);
  }
  initialize();
  scheduleProgress();
  window.addEventListener('scroll', scheduleProgress, { passive: true });
  window.addEventListener('resize', scheduleProgress, { passive: true });
  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
    scheduleProgress();
  });
})();

/* Blog → PDP intent only. Ecommerce successes remain owned by Google & YouTube. */
(() => {
  if (window.neobayBlogProductTracking) return;
  window.neobayBlogProductTracking = true;

  const measurementId = 'G-R77W4HQJFL';
  const articlePattern = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/blogs\/[^/]+\/[^/]+\/?$/i;
  const productPattern = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?(?:\/collections\/[^/]+)?\/products\/([^/]+)\/?$/i;
  const short = (value) => String(value || '').slice(0, 100);

  // The storefront does not always preload this API. Unknown consent means no event.
  function loadPrivacy() {
    if (window.Shopify?.customerPrivacy || !window.Shopify?.loadFeatures) return;
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], () => {});
    } catch {
      // A blocked API must not interrupt reading or navigation.
    }
  }

  function track(event) {
    if (!event.isTrusted || (event.type === 'click' && event.button !== 0) ||
        (event.type === 'auxclick' && event.button !== 1) || window.Shopify?.designMode) return;
    if (!articlePattern.test(window.location.pathname)) return;
    const link = event.target?.closest?.('a[href]');
    if (!link || !link.closest('.blog-article-layout') || link.hasAttribute('download')) return;

    try {
      const destination = new URL(link.href, window.location.href);
      const product = destination.pathname.match(productPattern);
      if (destination.origin !== window.location.origin || !product) return;
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true ||
          typeof window.gtag !== 'function') return;

      let placement = 'body_link';
      if (link.closest('.bpc-card, .blog-product-card')) {
        placement = link.closest('.bpc-image') ? 'product_card_image' : 'product_card_cta';
      } else if (link.closest('.blog-article-sidebar')) {
        placement = 'sidebar';
      } else if (link.matches('.button, .btn, [role="button"]')) {
        placement = 'article_cta';
      }

      const articleId = window.ShopifyAnalytics?.meta?.page?.resourceId;
      window.gtag('event', 'blog_product_click', {
        send_to: measurementId,
        article_id: short(articleId),
        article_path: short(window.location.pathname),
        destination_path: short(destination.pathname),
        destination_handle: short(product[1]),
        placement,
        market: short(window.Shopify?.country),
        content_language: short(window.Shopify?.locale || document.documentElement.lang),
        transport_type: 'beacon',
      });
    } catch {
      // Analytics failures must never change the link's normal behavior.
    }
  }

  loadPrivacy();
  document.addEventListener('shopify:section:load', loadPrivacy);
  document.addEventListener('click', track, { capture: true, passive: true });
  document.addEventListener('auxclick', track, { capture: true, passive: true });
})();
